
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DiscountingPolicyDetailsGrid extends Serenity.EntityGrid<DiscountingPolicyDetailsRow, any> {
        protected getColumnsKey() { return 'OMS.DiscountingPolicyDetails'; }
        protected getDialogType() { return DiscountingPolicyDetailsDialog; }
        protected getIdProperty() { return DiscountingPolicyDetailsRow.idProperty; }
        protected getInsertPermission() { return DiscountingPolicyDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return DiscountingPolicyDetailsRow.localTextPrefix; }
        protected getService() { return DiscountingPolicyDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}